import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProcessoGerarDocService } from '@app/services/processo-gerardoc.service';
import { GerarDoc } from '@app/models/gerardoc.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { UtilitarioService } from '@app/services/utilitario.service';

@Component({
  selector: 'app-gerardoc',
  templateUrl: './gerardoc.component.html',
  styleUrls: ['./gerardoc.component.scss']
})
export class GerarDocComponent implements OnInit {

  bsModalRef: BsModalRef;
  lstGerarDoc: GerarDoc[] = [];
  processoId: number;
  download: boolean[] = [];
  lstErros: string[] = [];
  finalDaPagina = Number.MAX_SAFE_INTEGER;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoGerarDocService: ProcessoGerarDocService,
    private modalService: BsModalService,
    private utilitarioService: UtilitarioService
  ) { }

  ngOnInit() {

    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
        this.obterTodos();
      });
  }

  obterTodos() {
    this.processoGerarDocService.obterTodos().subscribe((data) => {
      this.lstGerarDoc = data;
      this.lstGerarDoc.forEach(() => this.download.push(false));

    });
  }

  obterArquivoMasculino(gerarDoc: GerarDoc, index: number) {
    this.download[index] = true;
    this.processoGerarDocService.gerarDoc(this.processoId, gerarDoc.Id, "M").subscribe((data) => {
      this.utilitarioService.saveAs(data, gerarDoc.Nome + gerarDoc.Extensao);
      this.download[index] = false;

    }, (data: any) =>{
      if (data.error){
        this.lstErros = data.error.errors;
        window.scrollTo(0, this.finalDaPagina);
        this.download[index] = false;
      }
    });

  }

  obterArquivoFeminino(gerarDoc: GerarDoc, index: number) {
    this.download[index] = true;
    this.processoGerarDocService.gerarDoc(this.processoId, gerarDoc.Id, "F").subscribe((data) => {
      this.utilitarioService.saveAs(data, gerarDoc.Nome + gerarDoc.Extensao);
      this.download[index] = false;

    }, (data: any) =>{
      if (data.error){
        this.lstErros = data.error.errors;
        window.scrollTo(1, this.finalDaPagina);
        this.download[index] = false;
      }
    });

  }

  deletar(gerarDoc: GerarDoc) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir o documento: " + gerarDoc.Nome;
    this.bsModalRef.content.confirmar = () => {
      this.processoGerarDocService.deletar(gerarDoc.Id).subscribe(() => {
        this.obterTodos();
      });
    }
  }
}

